import { createContext } from 'react'

const TransferListContext = createContext()

export default TransferListContext
